import React from 'react'
import PropTypes from 'prop-types';
import {Table, Pagination} from 'antd';//Pagination
import './style.css'

//表格组件
const TableView = (props) => {
    const {
        rowSelection,
        pageParam,
        rows,
        columns,
        loading,
        style,
        rowKey,
        scroll,
        paginationHide,
        expandedRowRender,
        language,
        onRowClick/*, expandedRowKeys, onExpandedRowsChange, onExpand*/
    } = props;

    const sizeChange = (current, size) => {
        pageParam.onChange(1, size);
    }

    const pagination = {
        total: pageParam.total,
        pageSize: pageParam.pageSize,
        pageSizeOptions: ['5', '10', '20', '30', '50', '100', String(pageParam.total)],
        showTotal: total => language == "en" ? `total ${total} rows` : `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        onShowSizeChange: sizeChange,
        onChange: pageParam.onChange,
        size: "small"
    };
    if (pageParam.current) {
        pagination.current = pageParam.current;
    }
    return <div style={{...style}}>
        <Table rowSelection={rowSelection || null}
               bordered
               rowKey={record => record[rowKey]}
               columns={columns}
               loading={loading || false}
               dataSource={rows}
               pagination={false}
               scroll={scroll}
               size="middle"
               expandedRowRender={expandedRowRender}
               onRowClick={onRowClick}
            // onExpandedRowsChange={onExpandedRowsChange}
            // onExpand={onExpand}
            // expandedRowKeys={expandedRowKeys || []}
        />
        {
            (rows && rows.length > 0 && !paginationHide) ?
                <div className="paginationBox">
                    <Pagination {...pagination} />
                </div>
                : ''
        }
    </div>
};
TableView.propTypes = {
    pageParam: PropTypes.shape({
        total: PropTypes.number.isRequired,
        current: PropTypes.number.isRequired,//当前页码
        pageSize: PropTypes.number.isRequired,//当前分页数
        onChange: PropTypes.func.isRequired,
    }).isRequired,
    rowSelection: PropTypes.shape({
        selectedRowKeys: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired,
        // onRowClick: PropTypes.func.isRequired,
    }),
    rowKey: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    columns: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
    style: PropTypes.object,
    expandedRowRender: PropTypes.func
    // onExpandedRowsChange: PropTypes.func,
    // onExpand: PropTypes.func,
    // expandedRowKeys: PropTypes.array
};
export default TableView



// WEBPACK FOOTER //
// ./src/components/tableView.js